import { api } from './customers'

export interface CustomerReminder {
    id: number
    customerId: number
    userId: number
    reminderTo: string
    reminderFor: string
    reminderOnce: string
    mediums: string
    status: string
    comments: string
}
  
type CustomerRemindersResponse = CustomerReminder[]


export const CustomerReminderApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerReminders: build.query<CustomerRemindersResponse, void>({
            query: () => 'reminder',
            providesTags: (result) =>
                result
                    ? [
                        ...result["data"]?.map(({ id }) => ({ type: 'CustomerReminder' as const, id })),
                        { type: 'CustomerReminder', id: 'LIST' },
                    ]
                    : [{ type: 'CustomerReminder', id: 'LIST' }],
        }),
        addCustomerReminder: build.mutation<CustomerReminder, Partial<CustomerReminder>>({
            query: (body) => ({
                url: `reminder`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: CustomerReminder }, meta, arg) => {
                return response.data
            },
            invalidatesTags: [{ type: 'Customer', id: 'LIST' }, { type: 'DasboardCustomers', id: 'LIST' }],

        }),
        getCustomerReminder: build.query<CustomerReminder, string>({
            query: (id) => `reminder/${id}`,
            transformResponse: (response: { data: CustomerReminder }, meta, arg) => response.data,
        }),
        getCustomerReminderByCustomerId: build.query<CustomerReminder, string>({
            query: (id) => `get_reminderBycustomerID/${id}`,
            transformResponse: (response: { data: CustomerReminder }, meta, arg) => response.data,
        }),
        updateCustomerReminder: build.mutation<void, Pick<CustomerReminder, 'id'> & Partial<CustomerReminder>>({
            query: ({ id, ...patch }) => ({
                url: `reminder/${id}`,
                method: 'PUT',
                body: patch,
            }),
            invalidatesTags: [{ type: 'Customer', id: 'LIST' }, { type: 'DasboardCustomers', id: 'LIST' }],

        }),
        getCustomerReminderHistory: build.query<CustomerReminder, any>({
            query: (pagi) => `reminder?page=${pagi?.pageNo}&customerId=${pagi?.id}`,
            providesTags: (result) =>
            result
                ? [
                    ...result["data"]?.map(({ id }) => ({ type: 'CustomerReminderHistory' as const, id })),
                    { type: 'CustomerReminderHistory', id: 'LIST' },
                ]
                : [{ type: 'CustomerReminderHistory', id: 'LIST' }],
        }),
        deleteCustomerReminder: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `reminder/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetCustomerReminderQuery,
    useGetCustomerRemindersQuery,
    useGetCustomerReminderByCustomerIdQuery,
    useAddCustomerReminderMutation,
    useUpdateCustomerReminderMutation,
    useGetCustomerReminderHistoryQuery,
    useDeleteCustomerReminderMutation,
} = CustomerReminderApi

